module.exports = __webpack_public_path__ + "static/media/soran.ef4f3859.jpg";